import {Route, Switch, Redirect, useRouteMatch} from 'react-router-dom';
import {isAuthenticated} from '../../auth';
import LoginPrompt from '../../auth/LoginPrompt';
import Header from './Layout/Header';
import Navigation from './Layout/Navigation';
import PersonalData, {URL_SLUG as PERSONAL_DATA_URL_SLUG} from './PersonalData';
import PaperSubmissionListing, {URL_SLUG as SUBMISSSIONS_URL_SLUG} from './PaperSubmissionListing';
import PaperSubmissionReviewListing, {URL_SLUG as REVIEWS_URL_SLUG} from './PaperSubmissionReviewListing';
import PaperSubmissionSessionListing, {URL_SLUG as SESSIONS_URL_SLUG} from './PaperSubmissionSessionListing';
import './styling.scss';

/**
 * Wrapper-Komponente für das Listing der zuvor getätigten Einreichungen
 *
 * @constructor
 */
const MyAreaContainer = () => {

    const {path} = useRouteMatch();

    return (
        <>
            <Header/>
            {isAuthenticated()
                ?
                <>
                    <Navigation/>
                    <div className="my-area-container">
                        <Switch>
                            <Route path={`${path}`} exact>
                                <Redirect to={`${path}/${SUBMISSSIONS_URL_SLUG}`}/>
                            </Route>
                            <Route path={`${path}/${SUBMISSSIONS_URL_SLUG}`} exact>
                                <PaperSubmissionListing/>
                            </Route>
                            <Route path={`${path}/${REVIEWS_URL_SLUG}`} exact>
                                <PaperSubmissionReviewListing/>
                            </Route>
                            <Route path={`${path}/${SESSIONS_URL_SLUG}`} exact>
                                <PaperSubmissionSessionListing />
                            </Route>
                            <Route path={`${path}/${PERSONAL_DATA_URL_SLUG}`} exact>
                                <PersonalData/>
                            </Route>
                        </Switch>
                    </div>
                </>
                : <div className="my-area-login">
                    <LoginPrompt/>
                </div>
            }
        </>
    );
}

export default MyAreaContainer;
